import i18next from "i18next";
import { initReactI18next } from "react-i18next";

import de_common from "./translations/de/common.json"
import de_navigation from "./translations/de/navigation.json"
import en_navigation from "./translations/en/navigation.json"
import en_form from "./translations/en/form.json"
import de_form from "./translations/de/form.json"
import fr_form from "./translations/fr/form.json"
import es_form from "./translations/es/form.json"

const resources = {
    en: {
        navigation: en_navigation,
        form: en_form,
    },
    de: {
        common: de_common,
        navigation: de_navigation,
        form: de_form,
    },
    fr: {
        form: fr_form,
    },
    es: {
        form: es_form,
    }
}

i18next
    .use(initReactI18next)
    .init({
        resources,
        lng: localStorage.getItem('language') ?? 'de'
    }).then(() => {});

export default i18next;
